import { useLocation, useNavigate } from 'react-router-dom'

export function useHashQueryParam(key: string, defaultValue = '') {
  const location = useLocation()
  const navigate = useNavigate()

  const read = (): string => {
    const query = location.hash.includes('?') ? location.hash.split('?')[1] : ''
    const value = new URLSearchParams(query).get(key)
    return value || defaultValue
  }

  const write = (value: string) => {
    const [pathPart, rawQuery = ''] = location.hash.replace(/^#/, '').split('?')
    const params = new URLSearchParams(rawQuery)
    params.set(key, value)
    navigate(`#${pathPart}?${params.toString()}`, { replace: true })
  }

  return [read, write] as const
}
